/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Konsultan_O3Inputs */

const en_mk_sol_konsultan_o3 = /** @type {(inputs: Mk_Sol_Konsultan_O3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A proven method does not leave when the person does`)
};

const id_mk_sol_konsultan_o3 = /** @type {(inputs: Mk_Sol_Konsultan_O3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Metode yang terbukti tidak hilang saat orangnya pindah`)
};

/**
* | output |
* | --- |
* | "A proven method does not leave when the person does" |
*
* @param {Mk_Sol_Konsultan_O3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_konsultan_o3 = /** @type {((inputs?: Mk_Sol_Konsultan_O3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Konsultan_O3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_konsultan_o3(inputs)
	return en_mk_sol_konsultan_o3(inputs)
});